import { render } from "./material_type.vue?vue&type=template&id=feb05aaa&scoped=true&ts=true"
import script from "./material_type.vue?vue&type=script&lang=ts"
export * from "./material_type.vue?vue&type=script&lang=ts"

import "./material_type.vue?vue&type=style&index=0&id=feb05aaa&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb05aaa"]])

export default __exports__